import {createContext} from 'react'
const datoContext = createContext()
export default datoContext